import { ReviewList } from './ReviewList';

export default ReviewList;
